import { motion } from 'framer-motion';

const socialLinks = [
//   {
//     name: 'Twitter',
//     href: 'https://x.com/purrtardio',
//     icon: (
//       <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 50 50" fill="currentColor">
//         <path d="M 5.9199219 6 L 20.582031 27.375 L 6.2304688 44 L 9.4101562 44 L 21.986328 29.421875 L 31.986328 44 L 44 44 L 28.681641 21.669922 L 42.199219 6 L 39.029297 6 L 27.275391 19.617188 L 17.933594 6 L 5.9199219 6 z M 9.7167969 8 L 16.880859 8 L 40.203125 42 L 33.039062 42 L 9.7167969 8 z"></path>
//       </svg>
//     )
//   },
  {
    name: 'Twitter2',
    href: 'https://x.com/purrto10',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 50 50" fill="currentColor">
        <path d="M 5.9199219 6 L 20.582031 27.375 L 6.2304688 44 L 9.4101562 44 L 21.986328 29.421875 L 31.986328 44 L 44 44 L 28.681641 21.669922 L 42.199219 6 L 39.029297 6 L 27.275391 19.617188 L 17.933594 6 L 5.9199219 6 z M 9.7167969 8 L 16.880859 8 L 40.203125 42 L 33.039062 42 L 9.7167969 8 z"></path>
      </svg>
    )
  },
  {
    name: 'Discord',
    href: 'https://discord.gg/8kfseQPyk6',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 50 50" fill="currentColor">
        <path d="M 30.980469 7 A 1.0001 1.0001 0 0 0 30.089844 7.5859375 C 30.089844 7.5859375 29.75543 8.3287993 29.546875 9.3964844 C 27.583844 9.08239 25.937423 9 25 9 C 24.062577 9 22.416156 9.08239 20.453125 9.3964844 C 20.24457 8.3287993 19.910156 7.5859375 19.910156 7.5859375 A 1.0001 1.0001 0 0 0 18.943359 7.0019531 A 1.0001 1.0001 0 0 0 18.919922 7.0039062 C 18.919922 7.0039062 12.553656 7.42053 8.3808594 10.714844 A 1.0001 1.0001 0 0 0 8.3125 10.773438 C 7.6051397 11.441499 7.0599467 12.483658 6.390625 13.972656 C 5.7213033 15.461655 5.0156888 17.355449 4.3671875 19.498047 C 3.0701848 23.783242 2 29.054167 2 34 A 1.0001 1.0001 0 0 0 2.1347656 34.5 C 3.6151076 37.06213 6.2964412 38.611763 8.8007812 39.582031 C 11.305121 40.552299 13.620576 40.938706 14.748047 40.998047 A 1.0001 1.0001 0 0 0 15.613281 40.583984 L 18.025391 37.222656 C 19.998188 37.682914 22.316458 38 25 38 C 27.683542 38 30.001812 37.682914 31.974609 37.222656 L 34.386719 40.583984 A 1.0001 1.0001 0 0 0 35.251953 40.998047 C 36.379424 40.938707 38.694879 40.552299 41.199219 39.582031 C 43.703559 38.611763 46.384892 37.06213 47.865234 34.5 A 1.0001 1.0001 0 0 0 48 34 C 48 29.054167 46.929815 23.783242 45.632812 19.498047 C 44.984311 17.355449 44.278697 15.461655 43.609375 13.972656 C 42.940053 12.483658 42.39486 11.4415 41.6875 10.773438 A 1.0001 1.0001 0 0 0 41.619141 10.714844 C 37.446345 7.4205261 31.080078 7.0039062 31.080078 7.0039062 A 1.0001 1.0001 0 0 0 30.980469 7 z M 18.5 21 C 17.047619 21 15.834562 21.674201 15.085938 22.636719 C 14.337312 23.599237 14 24.805556 14 26 C 14 27.194444 14.337313 28.400763 15.085938 29.363281 C 15.834561 30.325799 17.047619 31 18.5 31 C 19.952381 31 21.165439 30.325799 21.914062 29.363281 C 22.662687 28.400763 23 27.194444 23 26 C 23 24.805556 22.662688 23.599237 21.914062 22.636719 C 21.165439 21.674201 19.952381 21 18.5 21 z M 31.5 21 C 28.968421 21 27 23.315152 27 26 C 27 28.684848 28.968421 31 31.5 31 C 34.031579 31 36 28.684848 36 26 C 36 23.315152 34.031579 21 31.5 21 z"></path>
      </svg>
    )
  },
  {
    name: 'Docs',
    href: 'https://docs.purrtardio.com',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"></path>
        <rect x="9" y="3" width="6" height="4" rx="2"></rect>
        <line x1="9" y1="12" x2="15" y2="12"></line>
        <line x1="9" y1="16" x2="15" y2="16"></line>
      </svg>
    )
  },
  {
    name: 'Explorer',
    href: 'https://purrscan.com',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="10.5" cy="10.5" r="7.5"></circle>
        <path d="M21 21l-4.35-4.35"></path>
      </svg>
    )
  },
  {
    name: 'Linktree',
    href: 'https://linktr.ee/purrtardio',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
        <path d="m13.73635 5.85251 4.00467 -4.11665 2.3248 2.3808 -4.20064 4.00466h5.9085v3.30473h-5.9365l4.22865 4.10766 -2.3248 2.3338L12.0005 12.099l-5.74052 5.76852 -2.3248 -2.3248 4.22864 -4.10766h-5.9375V8.12132h5.9085L3.93417 4.11666l2.3248 -2.3808 4.00468 4.11665V0h3.4727zm-3.4727 10.30614h3.4727V24h-3.4727z" fill="currentColor"></path>
      </svg>
    )
  }
];

export function Footer() {
  return (
    <footer className="relative py-6 backdrop-blur-sm z-10">
      <div className="container mx-auto px-4">
        <div className="flex flex-col items-center">
          {/* Social Links */}
          <div className="flex space-x-6 mb-4">
            {socialLinks.map((item) => (
              <motion.a
                key={item.name}
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors duration-300"
                whileHover={{ 
                  scale: 1.1, 
                  color: ['#f0f0f0', '#a855f7', '#ec4899', '#f0f0f0'],
                  transition: { 
                    color: { repeat: Infinity, duration: 2 },
                    scale: { duration: 0.2 } 
                  }
                }}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4 }}
              >
                <span className="sr-only">{item.name}</span>
                {item.icon}
              </motion.a>
            ))}
          </div>
          
          {/* Copyright */}
          <motion.p 
            className="text-sm text-gray-400"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4 }}
          >
            © {new Date().getFullYear()} PURRTARDIO. All rights reserved.
          </motion.p>
        </div>
      </div>
    </footer>
  );
} 